import { Component, createRef } from 'react';

// project imports
import Datatable from 'shared/datatable';
import { getCaDetails } from 'shared/settings/apiconfig';
import { connect } from 'react-redux';
import moment from 'moment';
import * as momentTz from 'moment-timezone';
import DatePicker from "react-datepicker";
import { Modal, Form, Row, Col, Button, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { capitalizeFirstLetter } from 'shared/utils';


export class ClosedComplianceReport extends Component {

    config;
    initialSearchState;
    filterSearch;
    id;
    constructor(props) {
        super(props);
        this.dataTable = createRef();
        this.id = '';
        /* initial search state */
        this.initialSearchState = {
            email: { field: 'email', value: '', op: 'LIKE', join: 'AND' },
            starttime: { field: 'createdDate', value: '', op: '>=', join: 'AND' },
            firstname: { field: 'firstname', value: '', op: 'LIKE', join: 'AND' },
            lastname: { field: 'lastname', value: '', op: 'LIKE', join: 'AND' },
            phone: { field: 'phone', value: '', op: 'LIKE', join: 'AND' },
            endtime: { field: 'createdDate', value: '', op: '<=', join: 'AND' },
            status: { field: 'status', value: 'Closed',op: '=', join: 'AND'},
            requestid: { field: 'requestid', value: '', op: 'LIKE', join: 'AND' },
        }
        this.state = {
            search: this.initialSearchState,
            statusFilter: 'all',
            searchData: false,
            tableData: [],
            filterSearch: { },
            isActiveCheckbox: '',
            isDateFromCheckBox: false,
            checkedStartDateTime: '',
            checkedEndDateTime: '',
            startDate: '',
            endDate: '',
            editModal: {
                show: false,
                data: null,
                files: [],
                fileNames: [],
                actionTaken: ''
            }
        }

        this.config = {
            name: 'closedComplianceReport',
            url: getCaDetails,
            params: {},
            columns: [
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['view'], customHeader: <> </>, width: '50px',
                    actionEvents: {
                        view: (row, state) => {
                            this.handleViewClick(row);
                        },
                    },
                },
            
                { name: 'Request ID', property: 'requestid', sort: false, width: '140px' },
                { name: 'First Name', property: 'firstname', sort: true, width: '150px'},
                { name: 'Last Name', property: 'lastname', sort: true, width: '150px'},
                { name: 'Phone', property: 'phone', sort: true, width: '150px' },
                { name: 'Date', property: 'createdDate', sort: true, width: '150px', columnType: 'custom', customColumn: this.customCreatedDate },
                { name: 'Email', property: 'email', sort: true, width: '120px' },
                { name: 'Address', property: 'city', width: '150px', columnType: 'custom', customColumn: this.customAddress },
                { name: 'Type', property: 'righttype', width: '130px' },
                { name: 'Status', property: 'status', sortType: 'num', width: '50px',columnType: 'custom', customColumn: this.customStatus },
            ],
            sort: [{ field: 'createdDate', direction: 'desc' }],
            pagination: true,
            field: ['firstname', 'lastname', 'phone', 'createdDate', 'email', 'address1', 'status', 'file', 'name', 'actiontakennotes','imageurl', 'takeaction',"righttype",'city', 'state', 'zip', 'requestid'],
            adminUrl: {},
            ignoreRowBackground: true

        };

        if (props.location.state && props.location.state.datatable && props.location.state.datatable.search) {
           let tempSearch = { ...this.initialSearchState };
            const search = [...props.location.state.datatable.search];
            search.forEach(element => {
                let temp = { ...element };
                if (typeof temp['value'] === 'string') {
                    temp['value'] = temp['value'].replace(/(^\*)|(\*$)/g, '');
                }
                if (temp['field'] === "createdDate" && temp['op'] === '>=') {
                    temp['value'] = new Date(temp['value']);
                    temp['field'] = 'starttime';
                }
                if (temp['field'] === "createdDate" && temp['op'] === '<=') {
                    temp['value'] = new Date(temp['value']);
                    temp['field'] = 'endtime';
                }
              
                tempSearch[temp['field']] = temp;
            });
            this.state['search'] = tempSearch;
            this.state['searchData'] = true;
           
        }

        this.dataTable = createRef(); 
       
    }


    componentDidMount() { 
        if (!this.props?.location?.state?.datatable ) {
            this.enableSearch()
        } 
    }

    customDate = (value) => {
        if (value['modifieddate']) {
            return `${moment.utc(value['modifieddate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    };

    handleViewClick = (row) => {
        const files = this.normalizeToArray(row?.imageurl || row?.file);
        const fileNames = this.normalizeToArray(row?.name || row?.filename || row?.fileName);
        const actionTaken = row?.actiontakennotes || '';

        this.setState({
            editModal: {
                ...this.state.editModal,
                show: true,
                data: row,
                files,
                fileNames,
                actionTaken,
            }
        });
    }

    normalizeToArray = (value) => {
        if (Array.isArray(value)) {
            return value.filter(Boolean);
        }

        if (typeof value === 'string') {
            return value
                .split(',')
                .map((item) => item.trim())
                .filter(Boolean);
        }

        return [];
    }

    getFileNameFromUrl = (filePath = '') => {
        if (typeof filePath !== 'string' || !filePath) {
            return '';
        }

        try {
            const cleanUrl = filePath.split('?')[0].split('#')[0];
            const fileName = cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
            return decodeURIComponent(fileName || '');
        } catch (error) {
            return filePath;
        }
    }

    getFileTypeFromPath = (filePath = '') => {
        const fileName = this.getFileNameFromUrl(filePath).toLowerCase();
        if (!fileName || !fileName.includes('.')) {
            return 'Unknown';
        }
        return fileName.split('.').pop().toUpperCase();
    }

    handleCloseModal = () => {
        this.setState({
            editModal: {
                show: false,
                data: null,
                files: [],
                fileNames: [],
                actionTaken: ''
            }
        });
    }

    getPreviewType = (filePath = '') => {
        const file = (filePath || '').toLowerCase();
        if (file.match(/\.(jpg|jpeg|png|gif|bmp|webp|svg)$/)) {
            return 'image';
        }
        if (file.match(/\.(pdf)$/)) {
            return 'pdf';
        }
        return 'file';
    }

    shouldShowInlinePreview = (filePath = '') => {
        const previewType = this.getPreviewType(filePath);
        return previewType === 'image';
    }

    openFileInNewTab = (url) => {
        if (!url) return;
        window.open(url, '_blank', 'noopener,noreferrer');
    }

      customAddress = (values) => {
        return (values['city'] ? values['city'] + ', ' : '') + (values['state'] ? values['state'] + ', ' : '') + (values['zip'] ? values['zip'] : '');
    }


    customCreatedDate = (value) => {
        if (value['createdDate']) {
            return `${moment.utc(value['createdDate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    };

    customStatus = (value) => {
        if (value['status']) {
            return <span>{capitalizeFirstLetter(value['status'])}</span>
        }
        return '- - -';
    }

    enableSearch = () => {
        let search = {};
        let startDate = '';
        let endDate = '';

        if (this.state.search.starttime.value) {
            let startDateFormat = moment(this.state.search.starttime.value).format("YYYY-MM-DD")
            startDate = moment.tz(startDateFormat + ' 00:00:00', "US/Eastern").utc().format("YYYY-MM-DD hh:mm:ss")
        } else if (this.state.isDateFromCheckBox) {
            startDate = this.state.checkedStartDateTime || '';
        }

        if (this.state.search.endtime.value) {
            let endDateformat = moment(this.state.search.endtime.value).format("YYYY-MM-DD")
            endDate = moment.tz(endDateformat + ' 23:59:59', "US/Eastern").utc().format("YYYY-MM-DD hh:mm:ss")
        } else if (this.state.isDateFromCheckBox) {
            endDate = this.state.checkedEndDateTime || '';
        }


        search = {
            email: { ...this.state.search.email, value: this.state.search.email.value ? this.state.search.email.value : '' },
            starttime: { ...this.state.search.starttime, value: startDate || '' },
            firstname: { ...this.state.search.firstname, value: this.state.search.firstname.value ? this.state.search.firstname.value : '' },
            lastname: { ...this.state.search.lastname, value: this.state.search.lastname.value ? this.state.search.lastname.value : '' },
            phone: { ...this.state.search.phone, value: this.state.search.phone.value ? this.state.search.phone.value : '' },
            endtime: { ...this.state.search.endtime, value: endDate || '' },
            requestid: { ...this.state.search.requestid, value: this.state.search.requestid.value ? this.state.search.requestid.value : '' },
            status: { field: "status", value: 'Closed', op: "=", join: "AND" },
        }

        if (this.props?.location?.state) {
            this.setState({
                searchData: true
            })
        }
        this.setState({
            filterSearch: search,
            searchData: true,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }

    resetState = () => {
        this.setState({
            ...this.state,
            search: this.initialSearchState,
            statusFilter: 'all',
            isActiveCheckbox: '',
            isDateFromCheckBox: false,
            checkedStartDateTime: '',
            checkedEndDateTime: '',
            startDate: '',
            endDate: '',
            filterSearch: this.initialSearchState,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }
    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.enableSearch()
        }
    }
    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }
    searchInputChange = (event) => {
        let eventValue = event.target.value;
        this.setState({
            ...this.state,
            issearch: true,
            search: {
                ...this.state.search,
                [event.target.name]: {
                    ...this.state.search[event.target.name],
                    value: eventValue
                }
            }
        }, () => {
           
        });
    }
    setDate = (control, date) => {
        this.setState({
            ...this.state,
            issearch: true,
            isActiveCheckbox: '',
            isDateFromCheckBox: false,
            checkedStartDateTime: '',
            checkedEndDateTime: '',
            search: {
                ...this.state.search,
                [control]: {
                    ...this.state.search[control],
                    value: date
                },
            }
        });

    }

    onChangeCheckBox = (event) => {
        if (this.state.isActiveCheckbox === event) {
            this.setState({
                isActiveCheckbox: '',
                isDateFromCheckBox: false,
                checkedStartDateTime: '',
                checkedEndDateTime: ''
            }, this.enableSearch);
            return;
        }

        let starttime = '';
        let endtime = '';
        if (event == "yesterday") {
            let yesterday = moment().tz('US/Eastern').subtract(1, 'day');
            starttime = yesterday.clone().startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
            endtime = yesterday.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
        } else if (event == "week") {
            let dateTime = moment().tz('US/Eastern');
            starttime = dateTime.clone().startOf('isoWeek').utc().format('YYYY-MM-DD HH:mm:ss');
            endtime = dateTime.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
        } else if (event == "month") {
            let dateTime = moment().tz('US/Eastern');
            starttime = dateTime.clone().startOf('month').utc().format('YYYY-MM-DD HH:mm:ss');
            endtime = dateTime.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
        } else if (event == "year") {
            let dateTime = moment().tz('US/Eastern');
            starttime = dateTime.clone().startOf('year').utc().format('YYYY-MM-DD HH:mm:ss');
            endtime = dateTime.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
        } else if (event == "last_7days") {
            let startDateTime = moment().tz('US/Eastern').subtract(7, 'days');
            let endDateTime = moment().tz('US/Eastern').subtract(1, 'day');
            starttime = startDateTime.clone().startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
            endtime = endDateTime.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
        } else if (event == "last_30days") {
            let startDateTime = moment().tz('US/Eastern').subtract(30, 'days');
            let endDateTime = moment().tz('US/Eastern').subtract(1, 'day');
            starttime = startDateTime.clone().startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
            endtime = endDateTime.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
        } else if (event == "last_365days") {
            let startDateTime = moment().tz('US/Eastern').subtract(365, 'days');
            let endDateTime = moment().tz('US/Eastern').subtract(1, 'day');
            starttime = startDateTime.clone().startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
            endtime = endDateTime.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
        }

        this.setState({
            isActiveCheckbox: event,
            isDateFromCheckBox: true,
            checkedStartDateTime: starttime,
            checkedEndDateTime: endtime
        }, () => {
            this.setState({
                ...this.state,
                issearch: true,
                locationcheck: false,
                dateErrormsg:'',
                search: {
                    ...this.state.search,
                    starttime: {
                        ...this.state.search['starttime'],
                        value: ''
                    },
                    endtime: {
                        ...this.state.search['endtime'],
                        value: ''
                    }
                },
                startDate: '',
                endDate: '',
            }, () => {
               this.enableSearch()
            })
        })

    }

    render() {

        return (
            <div className="buyer-list">
                 <div className="sale-search">
                    <div className="sales-list-search">
                        <Form className="sales-list-font">
                            <div className="sales-search-container">

                                <Row>
                                 
                                    <Col>
                                        <label>Request ID</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="requestid" value={this.state.search.requestid.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                       <Col>
                                        <label>Email</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="email" value={this.state.search.email.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                    <Col>
                                        <label>First Name</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="firstname" value={this.state.search.firstname.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                    <Col>
                                        <label>Last Name</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="lastname" value={this.state.search.lastname.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                 
                                    

                                </Row>
                                 <Row>
                                      <Col>
                                        <label>Phone</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="phone" value={this.state.search.phone.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                            
                                    
                                    <Col>
                                        <label> Date From</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.start.state.open && e.preventDefault()}>
                                                <DatePicker ref={r => this.start = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.starttime.value} selected={this.state.search.starttime.value} onChange={date => { this.setDate('starttime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "12%", color: "#959393" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                    <Col>
                                        <label>Date To</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.end.state.open && e.preventDefault()}>
                                                <DatePicker minDate={this.state.search.starttime.value ? this.state.search.starttime.value : ''} ref={r => this.end = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.endtime.value} selected={this.state.search.endtime.value} onChange={date => { this.setDate('endtime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "12%", color: "#959393" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                    <Col>
                                    </Col>

                                   
                                </Row>
                                <Row className='checkbox-resp' style={{ width: '100%' }}>
                                    <div className='d-flex wt-50'>
                                        <Col>
                                            <div className={`d-flex align-items-center header`}>
                                                <div style={{ marginLeft: '10px' }}>
                                                    <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'yesterday' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('yesterday')}></div>
                                                </div>
                                                <div style={{ marginLeft: '5%' }}>
                                                    <div className='text-nowrap'>Yesterday</div>
                                                </div>
                                                <div style={{ marginLeft: '4%', marginTop: '1.5px' }}>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Yesterday'}</Tooltip>}>
                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className={`d-flex align-items-center header`}>
                                                <div style={{ marginLeft: '10px' }}>
                                                    <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'week' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('week')}></div>
                                                </div>
                                                <div style={{ marginLeft: '5%' }}>
                                                    <div className='text-nowrap'>Week to Date</div>
                                                </div>
                                                <div style={{ marginLeft: '4%', marginTop: '1.5px' }}>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Monday to today of current week'}</Tooltip>}>
                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        </Col>
                                    </div>
                                    <div className='d-flex wt-50'>
                                        <Col>
                                            <div className={`d-flex align-items-center header`}>
                                                <div style={{ marginLeft: '10px' }}>
                                                    <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'month' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('month')}></div>
                                                </div>
                                                <div style={{ marginLeft: '5%' }}>
                                                    <div className='text-nowrap'>Month to Date</div>
                                                </div>
                                                <div style={{ marginLeft: '4%', marginTop: '1.5px' }}>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'First day of the current month to current date'}</Tooltip>}>
                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className={`d-flex align-items-center header`}>
                                                <div style={{ marginLeft: '10px' }}>
                                                    <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'year' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('year')}></div>
                                                </div>
                                                <div style={{ marginLeft: '5%' }}>
                                                    <div className='text-nowrap'>Year to Date</div>
                                                </div>
                                                <div style={{ marginLeft: '4%', marginTop: '1.5px' }}>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'First day of the current year to current date'}</Tooltip>}>
                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        </Col>
                                    </div>
                                </Row>

                                <Row className='checkbox-resp' style={{ width: '100%' }}>
                                    <div className='d-flex wt-50'>
                                        <Col>
                                            <div className={`d-flex align-items-center header`}>
                                                <div style={{ marginLeft: '10px' }}>
                                                    <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'last_7days' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('last_7days')}></div>
                                                </div>
                                                <div style={{ marginLeft: '5%' }}>
                                                    <div className='text-nowrap'>Last 7 days</div>
                                                </div>
                                                <div style={{ marginLeft: '4%', marginTop: '1.5px' }}>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Past 7 days excluding current date'}</Tooltip>}>
                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className={`d-flex align-items-center header`}>
                                                <div style={{ marginLeft: '10px' }}>
                                                    <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'last_30days' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('last_30days')}></div>
                                                </div>
                                                <div style={{ marginLeft: '5%' }}>
                                                    <div className='text-nowrap'>Last 30 days</div>
                                                </div>
                                                <div style={{ marginLeft: '4%', marginTop: '1.5px' }}>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Past 30 days excluding current date'}</Tooltip>}>
                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        </Col>
                                    </div>
                                    <div className='d-flex wt-50'>
                                        <Col>
                                            <div className={`d-flex align-items-center header`}>
                                                <div style={{ marginLeft: '10px' }}>
                                                    <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'last_365days' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('last_365days')}></div>
                                                </div>
                                                <div style={{ marginLeft: '5%' }}>
                                                    <div className='text-nowrap'>Last 365 days</div>
                                                </div>
                                                <div style={{ marginLeft: '4%', marginTop: '1.5px' }}>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Past 365 days excluding current date'}</Tooltip>}>
                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col></Col>
                                    </div>
                                </Row>  
                                <div className="mt-3 mt-3 d-flex justify-content-end ">
                                            <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>
                                            <Button variant="search-button" onClick={() => this.enableSearch()}>Search</Button>
                                        </div>
                            </div>
                        </Form>

                    </div>
                </div>
                <div className="buyer-table">
                    <Datatable {...this.props} config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable}
                     onDataUpdate={this.updateTableData} />
                </div>

                <Modal
                    show={this.state.editModal.show}
                    onHide={this.handleCloseModal}
                    size="lg"
                    backdrop="static"
                    centered
                >
                    <Modal.Header closeButton >
                        <Modal.Title>Compliance Response View</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col md={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-bold">Uploaded File</Form.Label>
                                    <div className="border rounded p-4" style={{ minHeight: '180px' }}>
                                        {Array.isArray(this.state.editModal.files) && this.state.editModal.files.length ? (
                                            <div
                                                style={{
                                                    width: '100%',
                                                    display: 'grid',
                                                    gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
                                                    gap: '12px'
                                                }}
                                            >
                                                {this.state.editModal.files.map((fileUrl, index) => {
                                                    const fileName = this.state.editModal.fileNames[index] || this.getFileNameFromUrl(fileUrl);
                                                    return (
                                                        <div key={`closed-file-${index}`} className="position-relative" style={{ minWidth: 0 }}>
                                                            <Button
                                                                variant="info"
                                                                size="sm"
                                                                className="position-absolute"
                                                                style={{ top: '-10px', right: '-10px', color: '#fff' }}
                                                                onClick={() => this.openFileInNewTab(fileUrl)}
                                                                title="View"
                                                            >
                                                                <i className="fa fa-eye"></i>
                                                            </Button>

                                                            {this.shouldShowInlinePreview(fileUrl) ? (
                                                                <Image
                                                                    src={fileUrl}
                                                                    alt={`Uploaded file ${index + 1}`}
                                                                    style={{ width: '100%', height: '100px', objectFit: 'cover' }}
                                                                    className="border"
                                                                />
                                                            ) : (
                                                                <div className="border p-2 d-flex align-items-center justify-content-center" style={{ width: '100%', height: '100px' }}>
                                                                    <div className="text-center">
                                                                        <i className="fa fa-file text-muted" style={{ fontSize: '24px' }}></i>
                                                                        <div className="mt-1" style={{ fontSize: '10px', wordBreak: 'break-word' }}>
                                                                            {fileName || 'Download File'}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        ) : (
                                            <div className="text-muted">No uploaded file available.</div>
                                        )}
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <Form.Group className="mb-0">
                                    <Form.Label className="text-bold">Action Taken / Notes</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={4}
                                        readOnly
                                        value={this.state.editModal.actionTaken || 'No notes available.'}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center">
                        <Button variant="secondary" onClick={this.handleCloseModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}
export default connect(state => state)(ClosedComplianceReport);
